import { Stitch } from 'mongodb-stitch-browser-sdk';

if (process.env.REACT_APP_STITCH_ID == null) {
  throw new Error('Stitch ID environment variable is not defined!');
}

const client = Stitch.initializeDefaultAppClient(process.env.REACT_APP_STITCH_ID);

export default client;
